// extracted by mini-css-extract-plugin
export default {"fotterText":"bank-transaction-init-view_fotterText__W8PR3","input":"bank-transaction-init-view_input__P4WIs","arrow":"bank-transaction-init-view_arrow__+yVGK"};